module.exports = __webpack_public_path__ + "media/newstyle/images/book-type-red-f76930e5dcc4fab20cea20e80490d0d0.svg";